import { createSelector } from '@reduxjs/toolkit';
import { EMaxPrepay } from '../../../../packages/api-models/common/json_query';
import { selectPrepay } from 'shared/selectors/jsonQuery';

const OPTIONS = [
  { label: 'Неважно', value: EMaxPrepay.Any },
  { label: 'Не более 1 месяца', value: EMaxPrepay.Month },
  { label: 'Не более 2 месяцев', value: EMaxPrepay.TwoMonths },
  { label: 'Не более 3 месяцев', value: EMaxPrepay.ThreeMonths },
];

export const selectPrepayFilter = createSelector(selectPrepay, value => ({
  label: 'Предоплата',
  value: value !== null ? value : EMaxPrepay.Any,
  options: OPTIONS,
}));
